import React, { FC } from 'react'

import { NavigatorLayout } from 'components/templates/navigatorLayout'
import { BaseProps } from 'interfaces/categories.interface'
import Logo from 'public/svg/marry-baby-logo.svg'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const WrapperLayout = styled.div``

/**
 *
 * @param Component MainPage
 * @returns Component Additionally Layout of Categories Page
 */

const withCategory = <T extends BaseProps>(
  Component: FC<T>,
  Layout: FC = WrapperLayout,
) => {
  const LayoutCategory = (props: T & BaseProps) => {
    const { formatMessage: f } = useIntl()
    const { siteName: sitename, navigators } = props

    return (
      <Layout data-bg={props?.categoryInfo?.thumnailColor}>
        <NavigatorLayout
          title={f({ id: 'categories.seo.title' }) + ' | ' + sitename}
          description={f({ id: 'categories.seo.description' }, { sitename })}
          image="/images/bookDoctor.svg"
          SEOData={{ isIndexable: true, hasNoAmp: true }}
          logo={<Logo />}
          activeMenuService="categories"
          {...navigators}
        >
          <Component {...props} />
        </NavigatorLayout>
      </Layout>
    )
  }
  return LayoutCategory
}

export default withCategory
